export default __webpack_public_path__ + "static/media/2.e6a30d4f.png";